import { Strategy } from 'utility-ts-strategy';
import { ISectionStatusLabel } from '../../../interfaces/scheduler_interfaces';

export let SectionStatusLabelStrategy = new Strategy<ISectionStatusLabel>({
  REGISTERED: {
    text: 'Registered',
    style: 'enrolled',
    marker_color: 'clr-teal_30-txt'
  },
  IN_PROGRESS: {
    text: 'In Progress',
    style: 'enrolled',
    marker_color: 'clr-teal_30-txt'
  },
  COMPLETED: {
    text: 'Completed',
    style: 'enrolled',
    marker_color: 'clr-green_30-txt'
  },
  PENDING: {
    text: 'Pending',
    style: 'pending',
    marker_color: 'clr-gray_50-txt'
  },
  FAILED: {
    text: 'Unable to register',
    style: 'failed',
    marker_color: 'clr-red_30-txt'
  },
  WAITLISTED: {
    text: 'Waitlisted',
    style: 'enrolled',
    marker_color: 'clr-purple_30-txt'
  },
  NOT_REGISTERED: {
    text: 'Ready to register',
    style: 'failed',
    marker_color: 'clr-orange_30-bkg'
  },
  SECTION_PICKED: {
    text: 'Not Registered',
    style: 'clr-gray_40-txt',
    marker_color: 'clr-gray_40-txt'
  },
  SWAP_FROM: {
    text: 'Selected for swap',
    style: 'clr-gray_40-txt',
    marker_color: 'clr-gray_40-txt'
  },
  SWAP_TO: {
    text: 'New time selected',
    style: 'clr-gray_40-txt',
    marker_color: 'clr-gray_40-txt'
  },
  WITHDRAWN: {
    text: 'Withdrawn',
    style: 'clr-gray_40-txt',
    marker_color: 'clr-gray_40-txt'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/strategies/section_status_label_strategy.ts